import {AnySchema, boolean, mixed, object} from 'yup';

export const getNxFileValidationSchema = (required: boolean, requiredError: string): AnySchema =>
  required
    ? object({file: mixed().nullable().required(requiredError), isChanged: boolean()}).nullable()
    : object({file: mixed().nullable(), isChanged: boolean()}).nullable();
